module.exports = __webpack_public_path__ + "static/img/top_chat_gpt.6fb7fe53.jpg";